import {OrderDetailsShipmentEvent} from '../../../../types';
import {LabelValue} from '@/types';

import LabelValueList from '../label-value-list';
import ShipmentTracking from '../shipment-tracking';

import './index.css';

interface SectionDetailsContentProps {
  firstRow?: LabelValue[];
  secondRow?: LabelValue[];
  trackingEvents?: OrderDetailsShipmentEvent[];
  shipmentUrl?: string;
  shipmentData?: LabelValue[];
  carrier?: string;
}

const SectionDetailsContent = (props: SectionDetailsContentProps) => {
  const {
    firstRow,
    secondRow,
    trackingEvents,
    shipmentUrl,
    shipmentData,
    carrier,
  } = props;

  return (
    <div className="SectionDetailsContent">
      <div className="SectionDetailsContent__details">
        <LabelValueList
          data={firstRow}
          className="SectionDetailsContent__container"
          bold={false}
        />
        <LabelValueList
          data={secondRow}
          className="SectionDetailsContent__container"
          bold={false}
        />
      </div>
      <ShipmentTracking
        trackingEvents={trackingEvents}
        shipmentUrl={shipmentUrl}
        shipmentData={shipmentData}
        carrier={carrier}
      />
    </div>
  );
};

export default SectionDetailsContent;
